<template>
  <section-container>
    <header-page
      title_header="Redes sociais"
      sub_header="Altere suas redes sociais"
    />
    <content-e class="p-2">
      <div class="bg-white shadow-2l rounded p-6 w-full">
        <h2
          class="text-md font-bold mb-4 pb-4 border-b border-dashed block w-full"
        >
          Informações
        </h2>
        <form
          action=""
          class="flex flex-wrap w-full"
          @submit.prevent="doStoreContacts"
          ref="formCategories"
        >
          <div class="w-full md:w-2/3 p-2 mx-auto">
            <div class="flex flex-wrap">
              <div class="w-full p-2">
                <input-icon
                  :icon="{ name: 'facebook', type: 'logo' }"
                  id="contact_facebook"
                  name="contact_facebook"
                  type="text"
                  v-model="contacts.facebook"
                  label="Facebook:"
                ></input-icon>
                <small
                  >https://facebook.com/<strong>{{
                    contacts.facebook
                  }}</strong></small
                >
              </div>
              <div class="w-full p-2">
                <input-icon
                  :icon="{ name: 'instagram', type: 'logo' }"
                  id="contact_instagram"
                  name="contact_instagram"
                  type="text"
                  v-model="contacts.instagram"
                  label="Facebook:"
                ></input-icon>
                <small
                  >https://instagram.com/<strong>{{
                    contacts.instagram
                  }}</strong></small
                >
              </div>
              <div class="w-full p-2">
                <input-icon
                  :icon="{ name: 'mail-send' }"
                  id="contact_email"
                  name="contact_email"
                  type="email"
                  v-model="contacts.email"
                  label="Email:"
                ></input-icon>
              </div>
              <div class="w-full p-2">
                <button-icon
                  icon="plus"
                  text="Atualizar Categoria"
                  class="bg-indigo-600"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </content-e>
  </section-container>
</template>

<script>
export default {
  components: {},
  computed: {
    storeId() {
      return this.$store.state.store.id
    }
  },
  data() {
    return {
      name: '',
      description: '',
      contacts: {
        whatsapp: '',
        facebook: '',
        instagram: '',
        email: ''
      }
    }
  },
  methods: {
    async getStore() {
      const store = await this.$store.dispatch('store/MY_STORES')
      this.contacts = store.data.contacts
      this.name = store.data.name
      this.description = store.data.description
    },
    async doStoreContacts() {
      this.$store
        .dispatch('store/PUT_UPDATE_STORE', {
          name: this.name,
          description: this.description,
          contacts: this.contacts
        })
        .then(response => {
          this.$toasted.success('Atualizado com sucesso', {
            position: 'bottom-center',
            duration: 5000,
            icon: 'check'
          })
          this.$router.push({
            name: 'settings.index'
          })
        })
        .catch(error => {
          if (error.status === 422) {
            const msg = Object.values(error.data.errors)
            msg.forEach((item, i) => {
              this.$toasted.error(item, {
                position: 'top-center',
                duration: 5000,
                icon: 'close'
              })
            })
          }
          if (error.status === 405) {
            this.$toasted.error(error.data.message, {
              position: 'top-center',
              duration: 5000,
              icon: 'close'
            })
          }
        })
    }
  },
  async beforeMount() {
    this.getStore()
  }
}
</script>

<style></style>
